import React from 'react';
import PropTypes from 'prop-types';

import InstructionText from 'components/parking-passes/parking-instructions/instruction-text';
import HowToPark from 'components/parking-passes/parking-instructions/how-to-park';
import LocationFeatures from 'components/parking-passes/parking-instructions/location-features';
import ResellerNotice from 'components/parking-passes/parking-instructions/reseller-notice';
import PassActions from 'components/parking-passes/parking-instructions/pass-actions';
import Divider from 'components/parking-passes/parking-instructions/divider';
import HelpAndSupport from 'components/parking-passes/parking-instructions/help-and-support';
import PricingInstructions from 'components/parking-passes/parking-instructions/pricing-instructions';
import ShuttleTimeInformation from 'components/common/shuttle-time-information';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import { Location as LocationModel } from 'models/locations';
import VenueModel from 'models/venue';
import Brand from 'models/brand';

const propTypes = {
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
  location: PropTypes.instanceOf(LocationModel).isRequired,
  venue: PropTypes.instanceOf(VenueModel),
  brand: PropTypes.instanceOf(Brand).isRequired,
};

const defaultProps = {
  venue: null,
};

const ParkingInstructions = ({ parkingPass, location, venue, brand }) => (
  <div className="container parking-instructions">
    <InstructionText title="Need To Know" titleId="parking-pass.need-to-know" content={parkingPass.disclaimers} />
    <ShuttleTimeInformation
      shuttleTimesToVenue={parkingPass.shuttleTimesToVenue}
      shuttleTimesFromVenue={parkingPass.shuttleTimesFromVenue}
      wrapperClassName="col-xs-10 col-xs-offset-1 col-md-9 col-md-offset-0 col-gutter-0 margin-top-20 margin-bottom-10"
      headerClassName="text-color-dark-slate text-size-xs-16 text-size-md-24 text-weight-bold"
      subheaderClassName="text-color-dark-slate text-size-xs-16 text-size-md-20 text-weight-bold margin-top-10"
      rowClassName="row text-color-slate text-size-14 margin-top-10"
    />
    <PricingInstructions parkingPass={parkingPass} venue={venue} />
    <ResellerNotice parkingPass={parkingPass} />
    <Divider visible={!!(parkingPass.disclaimers || parkingPass.resellerPass)} mobileOnly />
    <HowToPark parkingPass={parkingPass} />
    <Divider visible mobileOnly />
    <InstructionText title="WHERE TO GO" titleId="parking-pass.where-to-go" content={location.directions} />
    <Divider visible={!!location.directions} mobileOnly />
    <LocationFeatures amenities={parkingPass.validAmenities} />
    <Divider visible />
    <PassActions
      parkingPass={parkingPass}
      brand={brand}
    />
    <HelpAndSupport brand={brand} />
  </div>
);

ParkingInstructions.propTypes = propTypes;
ParkingInstructions.defaultProps = defaultProps;

export default ParkingInstructions;
